<template>
  <H5Layout title="文件管理" active="document">
    <ZDocument></ZDocument>
  </H5Layout>
</template>

<script>
import H5Layout from "./H5Layout.vue";
import ZDocument from "@/vue_views/ZDocument.vue";

export default {
  name: "DocumentH5",
  components: {
    H5Layout,
    ZDocument
  }
}
</script>

<style>
/* 文件管理表格在移动端适配 */
.h5-layout .Document-container .el-table__body-wrapper {
  overflow-x: auto;
}
.h5-layout .Document-container .inline-audio {
  width: 100%;
}
</style>
